import { Stack, Typography } from '@mui/material'
import ArrowRightWhiteSvg from '~/@ui/_sharedSvgs/ui/ArrowRightWhite2.svg?react'

type Props = {
  text: string
  onClick: () => void
  className?: string
}

export const FaqCard = ({ text, onClick, className = '' }: Props) => {
  return (
    <Stack
      className={`flex-row justify-between items-center gap-4 p-4 bg-zBlack300 rounded-4d ${className}`}
      onClick={onClick}>
      <Typography className="text-3d font-medium text-zWhite200">
        {text}
      </Typography>
      <ArrowRightWhiteSvg className="flex-shrink-0" />
    </Stack>
  )
}
